<template>
  <transition name="fade" appear>
    <div class="p-change-menu" :class="[`p-change-menu--${device}`]">
      <h2 class="p-change-menu__ttl c-ttl2">
        {{ identifier | getIdentifierName }}
      </h2>
      <p class="p-change-menu__txt">{{ selectItemName }}</p>

      <template v-if="
        identifier === 'gtsExteriorRoof' ||
        identifier === 'gtsExteriorAero' ||
        identifier === 'gtsExteriorExhaust'
      ">
        <div class="p-change-menu__btns">
          <div v-for="(item, index) in menu" :key="index">
            <!-- // アルピーヌコードに紐づいた処理 -->
            <button
              class="p-change-menu__btn c-btn3"
              @click.stop="changeMenu(item.code)"
              v-if="!isStoppedItem(item.code)"
              :class="[
                selectItemCode == item.code ? 'is-current' : '',
                identifier === 'gtsExteriorExhaust'
                  ? 'p-change-menu__btn--large'
                  : ''
              ]"
            >
              <span class="c-btn3__inner">
                <span>{{ item.name }}</span>
              </span>
            </button>
          </div>
        </div>
      </template>

      <template v-else-if="identifier === 'roof'">
        <div class="p-change-menu__btns">
          <div v-for="(item, index) in menu" :key="index">
            <!-- // アルピーヌコードに紐づいた処理 -->
            <button
              class="p-change-menu__btn c-btn3"
              @click.stop="changeMenu(item.code)"
              v-if="!isStoppedItem(item.code)"
              :class="[
                selectItemCode == item.code ? 'is-current' : '',
                gradeFirstLetter === 'G' || gradeFirstLetter === 'H'
                  ? 'p-change-menu__btn--large'
                  : ''
              ]"
            >
              <span class="c-btn3__inner">
                <span>{{ item.name }}</span>
              </span>
            </button>
          </div>
        </div>
      </template>

      <template v-else-if="identifier === 'tire'">
        <div class="p-change-menu__btns">
          <div v-for="(item, index) in menu" :key="index">
            <button
              class="p-change-menu__btn p-change-menu__btn--large2 c-btn3"
              @click.stop="changeMenu(item.code)"
              v-if="!isStoppedItem(item.code)"
              :class="[selectItemCode === item.code ? 'is-current' : '']"
            >
              <span class="c-btn3__inner">
                <span>{{ item.name }}</span>
              </span>
            </button>
          </div>
        </div>
      </template>

      <template v-else-if="identifier === 'handle'">
        <div class="p-change-menu__btns">
          <button
            class="p-change-menu__btn c-btn3"
            @click="changeHandle('left')"
            :class="[handle === 'left' ? 'is-current' : '']"
          >
            <span class="c-btn3__inner">
              <span>左ハンドル</span>
            </span>
          </button>
          <button
            class="p-change-menu__btn c-btn3"
            @click="changeHandle('right')"
            :class="[handle === 'right' ? 'is-current' : '']"
          >
            <span class="c-btn3__inner">
              <span>右ハンドル</span>
            </span>
          </button>
        </div>
      </template>

      <template v-else-if="identifier === 'color' && carType === 'a110gts'">
        <div class="p-change-menu__slide__wrap" v-if="multiMenuCurrent === 'default'">
          <h3 class="p-change-menu__ttl2 c-ttl2">
            スタンダードカラー
          </h3>
          <div class="p-change-menu__slide">
            <div class="p-change-menu__slide__inner">
              <div class="p-change-menu__slide__inner2">
                <ul class="p-change-menu__slide__list">
                  <li
                    class="p-change-menu__slide__list__item p-change-menu__slide__list__item--large"
                    v-if="isMultiMenu"
                    @click.stop="changeMultiMenu()"
                    :class="[multiMenuCurrent !== 'default' ? 'is-back' : '']"
                  >
                    <span>
                      <img :src="changeColorThumbUrl" alt />
                    </span>
                  </li>
                  <template v-for="(item, index) in menu.default">
                    <li
                      class="p-change-menu__slide__list__item"
                      @click.stop="changeMenu(item.code)"
                      :class="[selectItemCode === item.code ? 'is-current' : '']"
                      :key="index"
                      v-if="!isStoppedItem(item.code)"
                    >
                      <span>
                        <img
                          :src="item.code | getThumbUrl(identifier, carType)"
                          alt
                        />
                      </span>
                    </li>
                  </template>
                </ul>
                <button
                  class="c-btn2 c-btn2--prev p-change-menu__slide__prev is-disabled"
                >
                  前へ
                </button>
                <button
                  class="c-btn2 c-btn2--next p-change-menu__slide__next is-disabled"
                >
                  次へ
                </button>
              </div>
            </div>
          </div>
        </div>
        <template v-else>
          <div class="p-change-menu__slides">
            <div class="p-change-menu__slide__wrap">
              <h3 class="p-change-menu__ttl2 c-ttl2">
                ヘリテージカラー
              </h3>
              <div class="p-change-menu__slide">
                <div class="p-change-menu__slide__inner">
                  <div class="p-change-menu__slide__inner2">
                    <ul class="p-change-menu__slide__list">
                      <li
                        class="p-change-menu__slide__list__item is-back"
                        @click.stop="changeMultiMenu()"
                      >
                        <span>
                          <img :src="changeColorThumbUrl" alt />
                        </span>
                      </li>
                      <template v-for="(item, index) in menu.atelier">
                        <li
                          class="p-change-menu__slide__list__item"
                          @click.stop="changeMenu(item.code)"
                          :class="[selectItemCode === item.code ? 'is-current' : '']"
                          :key="index"
                          v-if="!isStoppedItem(item.code)"
                        >
                          <span>
                            <img
                              :src="item.code | getThumbUrl(identifier, carType)"
                              alt
                            />
                          </span>
                        </li>
                      </template>
                    </ul>
                    <button
                      class="c-btn2 c-btn2--prev p-change-menu__slide__prev is-disabled"
                    >
                      前へ
                    </button>
                    <button
                      class="c-btn2 c-btn2--next p-change-menu__slide__next is-disabled"
                    >
                      次へ
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-change-menu__slide__wrap">
              <h3 class="p-change-menu__ttl2 c-ttl2">
                アトリエエクスクルーシブカラー
              </h3>
              <div class="p-change-menu__slide">
                <div class="p-change-menu__slide__inner">
                  <div class="p-change-menu__slide__inner2">
                    <ul class="p-change-menu__slide__list">
                      <li
                        class="p-change-menu__slide__list__item is-back"
                        @click.stop="changeMultiMenu()"
                      >
                        <span>
                          <img :src="changeColorThumbUrl" alt />
                        </span>
                      </li>
                      <template v-for="(item, index) in menu.exclusive">
                        <li
                          class="p-change-menu__slide__list__item"
                          @click.stop="changeMenu(item.code)"
                          :class="[selectItemCode === item.code ? 'is-current' : '']"
                          :key="index"
                          v-if="!isStoppedItem(item.code)"
                        >
                          <span>
                            <img
                              :src="item.code | getThumbUrl(identifier, carType)"
                              alt
                            />
                          </span>
                        </li>
                      </template>
                    </ul>
                    <button
                      class="c-btn2 c-btn2--prev p-change-menu__slide__prev is-disabled"
                    >
                      前へ
                    </button>
                    <button
                      class="c-btn2 c-btn2--next p-change-menu__slide__next is-disabled"
                    >
                      次へ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <div class="p-change-menu__slide" v-else>
        <div class="p-change-menu__slide__inner">
          <div class="p-change-menu__slide__inner2">
            <ul class="p-change-menu__slide__list">
              <li
                class="p-change-menu__slide__list__item p-change-menu__slide__list__item--large"
                v-if="isMultiMenu"
                @click.stop="changeMultiMenu()"
                :class="[multiMenuCurrent !== 'default' ? 'is-back' : '']"
              >
                <span>
                  <img :src="changeColorThumbUrl" alt />
                </span>
              </li>
              <template v-for="(item, index) in menu">
                <li
                  class="p-change-menu__slide__list__item"
                  @click.stop="changeMenu(item.code)"
                  :class="[selectItemCode === item.code ? 'is-current' : '']"
                  :key="index"
                  v-if="!isStoppedItem(item.code)"
                >
                  <span>
                    <img
                      :src="item.code | getThumbUrl(identifier, carType)"
                      alt
                    />
                  </span>
                </li>
              </template>
            </ul>
            <button
              class="c-btn2 c-btn2--prev p-change-menu__slide__prev is-disabled"
            >
              前へ
            </button>
            <button
              class="c-btn2 c-btn2--next p-change-menu__slide__next is-disabled"
            >
              次へ
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getHandleName, getThumbUrl } from "../util/util";
import { getIdentifierName } from "../util/filter";
import Swiper, { Navigation } from "swiper"; // eslint-disable-line

export default {
  name: "ChangeMenu",
  props: {
    identifier: String,
    identifierName: String,
    selectedItem: Object,
    selectMenu: Array | Object, // eslint-disable-line
    stoppedEnditems: {
      colors: Array
    },
    gtsExteriorMap: Object,
    gtsExteriorAeroCombination: Object,
    device: String
  },
  data() {
    return {
      multiMenuCurrent: "default",
      // swiper: null
    };
  },
  computed: {
    // 多段メニューかどうかの判定
    isMultiMenu() {
      // 特定のkeyを持っていたら多段メニューとなる
      if (
        this.selectMenu &&
        Object.prototype.hasOwnProperty.call(this.selectMenu, "atelier")
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectItemName() {
      // ハンドルだけ別処理
      if (this.identifier === "handle") {
        return getHandleName(this.grade);
      }

      if (!this.selectMenu || !this.selectItemCode) return;
      // 多段メニュー構造になっていない場合
      if (this.selectMenu[this.selectItemCode]) {
        return this.selectMenu[this.selectItemCode].name;
      }
      // 多段メニュー構造になっている場合は一つ下の階層からマッチするものを探す
      else {
        let item = {};
        Object.keys(this.selectMenu).forEach(key => {
          if (this.selectMenu[key] && this.selectMenu[key][this.selectItemCode]) {
            item = this.selectMenu[key][this.selectItemCode];
            return;
          }
        });
        return item.name;
      }
    },
    selectItemCode() {
      return this.selectedItem.enditem[this.identifier];
    },
    changeColorThumbUrl() {
      return "./assets/img/img_color_select_01.jpg";
    },
    grade() {
      return this.selectedItem.enditem.grade;
    },
    gradeFirstLetter() {
      if (!this.grade) return;
      return this.selectedItem.enditem.grade.charAt(0);
    },
    handle() {
      if (!this.gradeFirstLetter) return;
      // アルピーヌコードに紐づいた処理
      if (this.gradeFirstLetter === "J" || this.gradeFirstLetter === "G") {
        return "right";
      } else {
        return "left";
      }
    },
    menu() {
      let selectMenu;
      let result = {};

      // 多段メニューかつa110gtsのカラーだった場合
      // アルピーヌコードに紐づいた処理
      if (
        this.isMultiMenu &&
        this.carType === "a110gts" &&
        this.identifier === "color"
      ) {
        selectMenu = this.selectMenu;
      }
      // 多段メニューだった場合
      else if (this.isMultiMenu) {
        selectMenu = this.selectMenu[this.multiMenuCurrent];
      }
      // 多段メニューではないが、defaultというkeyを持っている場合
      else if(this.selectMenu && this.selectMenu.default) {
        selectMenu = this.selectMenu.default;
      }
      else {
        selectMenu = this.selectMenu;
      }
      if (!selectMenu) return;

      // 直データは書き換えたくないためコピー
      selectMenu = { ...selectMenu };

      // a110gtsのExhaustはAeroの選択状態によって表示を制限する
      // アルピーヌコードに紐づいた処理
      if (
        this.gtsExteriorAeroCombination &&
        this.carType === "a110gts" &&
        this.identifier === "gtsExteriorExhaust"
      ) {
        let endItem = this.selectedItem.enditem;
        const gtsExteriorAero = endItem.gtsExteriorAero;
        const gtsExteriorAeroCombination = this.gtsExteriorAeroCombination[
          gtsExteriorAero
        ];

        if (gtsExteriorAeroCombination) {
          selectMenu = Object.keys(selectMenu)
            .filter(key => gtsExteriorAeroCombination.includes(Number(key)))
            .reduce((accumulator, key) => {
              accumulator[key] = selectMenu[key];
              return accumulator;
            }, {});
        }
      }

      if (
        this.isMultiMenu &&
        this.carType === "a110gts" &&
        this.identifier === "color"
      ) {
        result.default = this.getObjectToArray(selectMenu.default);
        result.atelier = this.getObjectToArray(selectMenu.atelier);
        result.exclusive = this.getObjectToArray(selectMenu.exclusive);
      } else {
        result = this.getObjectToArray(selectMenu);
      }

      return result;
    },
    carType() {
      return this.$route.params.cartype;
    },
    // 受注停止のものが存在するオプションかどうか判定
    isStoppedOptions() {
      return false;
    },
  },
  mounted() {
    this.slide();
  },
  methods: {
    getObjectToArray(obj) {
      let objectToArray = [];
      if(!obj) return objectToArray;
      // オブジェクトだと並び順が保証されないため、配列に変換する
      Object.keys(obj).forEach(function(key) {
        obj[key].code = key;
        objectToArray.push(obj[key]);
      });

      // orderキーを元に並べ替える
      objectToArray.sort(function(a, b) {
        if (a.order < b.order) {
          return -1;
        } else {
          return 1;
        }
      });

      return objectToArray;
    },
    changeMenu(code) {
      // 現状current状態だったら処理しない
      if (code === this.selectItemCode) return;

      let newCode = code;
      let identifier = this.identifier;
      let endItem = this.selectedItem.enditem;
      let gtsExteriors = {};

      // gts系はBTOコードとしてできるものに変更して返却する
      // アルピーヌコードに紐づいた処理
      if (
        this.carType === "a110gts" &&
        (this.identifier === "gtsExteriorRoof" ||
          this.identifier === "gtsExteriorAero" ||
          this.identifier === "gtsExteriorExhaust")
      ) {
        const gtsExteriorRoof =
          this.identifier === "gtsExteriorRoof"
            ? code - 0
            : endItem.gtsExteriorRoof;
        const gtsExteriorAero =
          this.identifier === "gtsExteriorAero"
            ? code - 0
            : endItem.gtsExteriorAero;
        let gtsExteriorExhaust =
          this.identifier === "gtsExteriorExhaust"
            ? code - 0
            : endItem.gtsExteriorExhaust;

        const gtsExteriorAeroCombination = this.gtsExteriorAeroCombination[gtsExteriorAero];
        const isAvilableExhaust = gtsExteriorAeroCombination.some(
          i => i === gtsExteriorExhaust
        );
        gtsExteriorExhaust = isAvilableExhaust
          ? gtsExteriorExhaust
          : gtsExteriorAeroCombination[0];

        gtsExteriors = {
          gtsExteriorRoof: gtsExteriorRoof,
          gtsExteriorAero: gtsExteriorAero,
          gtsExteriorExhaust: gtsExteriorExhaust,
        };

        newCode =  this.getGtsRoofCode(gtsExteriors);
        identifier = "roof";
      }

      this.$emit("change-menu", newCode, identifier);
    },
    // gts系の一部アイテムのBTOコードを割り出す
    getGtsRoofCode(gtsExteriors) {
      const getGtsRoofCode = Object.keys(this.gtsExteriorMap).filter(key =>
        Object.keys(gtsExteriors).every(
          gtsExteriorsKey =>
            this.gtsExteriorMap[key][gtsExteriorsKey] ===
            gtsExteriors[gtsExteriorsKey]
        )
      );
      return getGtsRoofCode[0];
    },

    slide() {
      new Swiper(".p-change-menu__slide__inner2", {
        freeMode: true,
        slidesPerView: "auto",
        // slidesPerView: 5.6,
        spaceBetween: 8,
        slidesPerGroup: 4,
        wrapperClass: "p-change-menu__slide__list",
        slideClass: "p-change-menu__slide__list__item",
        navigation: {
          nextEl: ".p-change-menu__slide__next",
          prevEl: ".p-change-menu__slide__prev",
          disabledClass: "is-disabled"
        },
        breakpoints: {
          1024: {
            spaceBetween: 10,
            slidesPerGroup: 10
          }
        }
      });
    },
    changeMultiMenu() {
      this.multiMenuCurrent =
        this.multiMenuCurrent === "default" ? "atelier" : "default";
      // // swiper更新のためにリサイズイベントを発火
      // let resize;
      // if(typeof(Event) === "function") {
      //   resize = new Event("resize");
      // } else {
      //   resize = document.createEvent("Event");
      //   resize.initEvent("resize", true, true);
      // }
      // setTimeout(() => {
      //   window.dispatchEvent(resize);
      // });
      setTimeout(() => {
        this.slide();
      });
    },
    changeHandle(direction) {
      if (this.handle === direction) return;
      this.$emit("change-grade", this.grade);
    },
    // 受注停止のアイテムかどうか判定
    // アルピーヌコードに紐づいた処理
    // MEMO:A110 Sのカーボルーフは受注再開するため条件を変更
    isStoppedItem(code) {
      // 受注停止のカラー用処理
      if (
        this.stoppedEnditems &&
        this.stoppedEnditems.colors &&
        this.identifier === "color"
      ) {
        return this.stoppedEnditems.colors.includes(code);
      } else {
        return false;
      }
    },
  },
  filters: {
    getThumbUrl,
    getIdentifierName
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
